import requests from '@/api/request'
import Cookie from "js-cookie";
import {removeAuthorization} from '@/utils/request'
let BASE_URL = `api`
let api = {
    DAHUALOGININFO: `${BASE_URL}/user/rasUserInfo`,//大华开始登陆客户端
    DAHUAUSERINFO: `${BASE_URL}/dahuaVideoDev/getHuiShangList`,//群组查询实时会商列表
    USERINFORMATION: `${BASE_URL}/user/rasAcdUserInformation`,//获取大华用户列表
    USERINFOS: `${BASE_URL}/user/rasAcdUserInfos`,// 获取大华用户用户详情
    KEEPALIVE: `${BASE_URL}/user/videoServiceAccountsTokenKeepalive`,//socket包活
    DELETEGROUP: `${BASE_URL}/dahuaVideoDev/imuGroupDelete`,//删除群组
    SETGROUP: `${BASE_URL}/dahuaVideoDev/imuGroupEdit`,//修改群组信息
    DAHUACONFIG: `${BASE_URL}/dahuaVideoDev/getDaHuaConfig`,//修改群组信息

    LOGINDH: `${BASE_URL}/user/loginToDaHua`,//登陆
    GETTOPDAHUADEV: `${BASE_URL}/dahuaVideoDev/getTopDaHuaDev`,//视频列表 -- 获取顶级节点大华视频设备
    GETCHILDDAHUADEV: `${BASE_URL}/dahuaVideoDev/getChildDaHuaDev`,//视频列表 -- 获取指定节点下级大华视频设备
    GETMANGELISTBYPAGE: `${BASE_URL}/dahuaVideoDev/getManageListByPage`,//视频管理 -- 分页获取大华视频设备(仅通道)
    GETVIDEOURL: `${BASE_URL}/dahuaVideoDev/getVideoUrl`,//视频列表 -- 大华视频设备通道获取视频URL
    SYNDAHUADEV: `${BASE_URL}/dahuaVideoDev/synDaHuaDev`,//同步大华视频设备
    DAHUAMODIFYBYID: `${BASE_URL}/dahuaVideoDev/modifyById`,//视频管理 -- 根据ID修改大华视频设备
    GETDAHUAVIDEODEVDETAILS: `${BASE_URL}/dahuaVideoDev/getDaHuaVideoDevDetails`,//视频管理 -- 获取大华视频设备详情
    KEEPDAHUATOKEN: `${BASE_URL}/user/keepDaHuaToken`,//大华Token保活
}
// 视频列表 -- 获取顶级节点大华视频设备
export async function getTopDaHuaDev(params) {
    return requests({
        url: api.GETTOPDAHUADEV,
        method: 'get',
        params,
        headers: {
            token: Cookie.get("tokenAdmin"),
        }
    }
    )
}

// 视频列表 -- 获取指定节点下级大华视频设备
export async function getChildDaHuaDev(params) {
    return requests({
        url: api.GETCHILDDAHUADEV,
        method: 'get',
        params,
        headers: {
            token: Cookie.get("tokenAdmin"),
        }
    }
    )
}

// 视频管理 -- 分页获取大华视频设备(仅通道)
export async function getManageListByPage(param) {
    const params = new URLSearchParams();
    for (var a in param) {
        params.append(a, param[a]);
    }
    return requests({
        url: api.GETMANGELISTBYPAGE,
        method: 'post',
        data: params,
        headers: {
            token: Cookie.get("tokenDH"),
        }
    });
}

// 视频列表 -- 大华视频设备通道获取视频URL
export async function getVideoUrl(params) {
    return requests({
        url: api.GETVIDEOURL,
        method: 'get',
        params,
        headers: {
            token: Cookie.get("tokenDH"),
        }
    }
    )
}

// 同步大华视频设备
export async function synDaHuaDev(params) {
    return requests({
        url: api.SYNDAHUADEV,
        method: 'get',
        params,
        headers: {
            token: Cookie.get("tokenDH"),
        }
    }
    )
}

// 视频管理 -- 根据ID修改大华视频设备
export async function modifyById(param) {
    const params = new URLSearchParams();
    for (var a in param) {
        params.append(a, param[a]);
    }
    return requests({
        url: api.DAHUAMODIFYBYID,
        method: 'post',
        data: params,
        headers: {
            token: Cookie.get("tokenDH"),
        }
    });
}

// 视频管理 -- 获取大华视频设备详情
export async function getDaHuaVideoDevDetails(params) {
    return requests({
        url: api.GETDAHUAVIDEODEVDETAILS,
        method: 'get',
        params,
        headers: {
            token: Cookie.get("tokenDH"),
        }
    }
    )
}

// 大华Token保活
export async function keepDaHuaToken(params) {
    return requests({
        url: api.KEEPDAHUATOKEN,
        method: 'get',
        params,
        headers: {
            token: Cookie.get("tokenDH"),
        }
    }
    )
}

// 大华开始登陆客户端
export async function daHuaLoginInfo(data) {
    return requests({
        url: api.DAHUALOGININFO,
        method: 'post',
        data,
        headers: {
            token: Cookie.get("tokenDH"),
            "Content-Type": "application/json;charset=UTF-8"
        }
    }
    )
}


// 群组查询实时会商列表

export async function daHuaUserInfo(params) {
    console.log(Cookie.get("tokenDH"));
    return requests({
        url: api.DAHUAUSERINFO,
        method: 'get',
        params,
        headers: {
            token: Cookie.get("tokenDH"),
            "Content-Type": "application/json;charset=UTF-8"
        }
    }
    )
}




// 获取大华用户
export async function userInformation(data) {
    return requests({
        url: api.USERINFORMATION,
        method: 'post',
        data,
        headers: {
            token: Cookie.get("tokenDH"),
            "Content-Type": "application/json;charset=UTF-8"
        }
    }
    );
}

// 获取大华用户用户详情
export async function userInfos(param) {
    const params = new URLSearchParams();
    for (var a in param) {
        params.append(a, param[a]);
    }
    return requests({
        url: api.USERINFOS,
        method: 'get',
        params,
        headers: {
            token: Cookie.get("tokenDH"),
            "Content-Type": "application/json;charset=UTF-8"
        }
    }
    );
}


// socket包活
export async function keepalive(data) {
    if (!Cookie.get("tokenDH")) return false;
    return requests({
        url: api.KEEPALIVE,
        method: 'post',
        data,
        headers: {
            token: Cookie.get("tokenDH"),
            "Content-Type": "application/json;charset=UTF-8"
        }
    }
    );
}


// 删除群组
export async function deleteGroup(param) {
    const params = new URLSearchParams();
    for (var a in param) {
        params.append(a, param[a]);
    }
    return requests({
        url: api.DELETEGROUP,
        method: 'post',
        data: params,
        headers: {
            token: Cookie.get("tokenDH"),
            "Content-Type": 'application/x-www-form-urlencoded; charset=UTF-8'
        }
    }
    )
}

// 修改群组信息
export async function setGroup(param) {
    const params = new URLSearchParams();
    for (var a in param) {
        params.append(a, param[a]);
    }
    return requests({
        url: api.SETGROUP,
        method: 'post',
        params,
        headers: {
            token: Cookie.get("tokenDH"),
            "Content-Type": "application/json;charset=UTF-8"
        }
    }
    )
}

//获取大户地址信息 
export const dhConfig = (data) => {
    return requests({
        url: '/api/dahuaVideoDev/getDaHuaConfig',
        method: 'get',
        data,
        headers: {
            // 'Contont-type': 'application/json',
        }
    })
}

// 登陆大华
export const loginDH = (param) => {
    const params = new URLSearchParams();
    for (var a in param) {
        params.append(a, param[a]);
    }
    return requests({
        url: '/api/user/loginToDaHua',
        method: 'get',
        params,
        headers: {
            // 'Contont-type': 'application/json',
            "token": Cookie.get("tokenAdmin")
        }
    })
}
// 退出登录
export async function goOut(param = {}) {
    return requests(
        {
            url: '/api/user/dahualogout',
            method: 'get',
            params: param,
            headers: {
                token: Cookie.get("tokenDH"),
            },
        });
}

export async function ecd(param) {
  
    return requests({
            url: `${BASE_URL}/dahuaVideoDev/getdevicecode`,
            method: 'post',
            data:param,
            headers: {
                token: Cookie.get("tokenDH"),
                "Content-Type": "application/json;charset=UTF-8"
            }
        }
    )
}


// 移除登陆信息
export function logout() {
    // console.log("退出登录 1111111111");
	localStorage.removeItem(process.env.VUE_APP_ROUTES_KEY);
	localStorage.removeItem(process.env.VUE_APP_PERMISSIONS_KEY);
	localStorage.removeItem(process.env.VUE_APP_ROLES_KEY);
	localStorage.removeItem("defaultConfigProtocol"),// 协议
	localStorage.removeItem("defaultConfigLoginIp"), // 环境配置
	localStorage.removeItem("defaultConfigPort"), // 端口配置
	localStorage.removeItem("defaultConfigCredential"), // 环境登陆账号
	localStorage.removeItem('dh')//大华账号登陆状态
	localStorage.removeItem('userInfo2.0')//用户信息
	localStorage.removeItem('checkEmergencyF'); // 菜单选中栏目
	localStorage.removeItem('checkEmergencyZ'); // 菜单选中栏目
    Cookie.remove('tokenDH')
    Cookie.remove('synchronizationStatus')
    // Cookie.remove('tokenAdmin')
    removeAuthorization();
}

